<template>
  <modal
    name="cancel-subscription-modal"
    classes="cancel-subscription-modal"
    height="auto"
  >
    <button
      class="close-btn"
      @click="$emit('close')"
    >
      <icon
        name="cross"
        variant="a1a1a1"
      />
    </button>
    <div class="warning-container">
      <icon
        name="warning"
        variant="white"
      />
    </div>
    <p class="title">
      {{ title }}
    </p>
    <p>Mastery is a journey, not a destination. Surely you aren’t already giving up on your goals? We’ll be waiting for you when you come back.</p>
    <ul>
      <li>Cancellation will be effective at the end of your current billing period on <span class="semi-bold">{{ subscriptionEndDate }}</span>.</li>
      <!-- Add once auto renew is enabled -->
      <!-- <li>Come back anytime! You can resume your subscription at your convenience by choosing “Resume auto renew” in your profile.</li> -->
    </ul>
    <button
      class="reset-btn"
      @click="$emit('endSubscription')"
    >
      {{ buttonText }}
    </button>
    <button
      class="cancel-btn"
      @click="$emit('close')"
    >
      Go Back
    </button>
  </modal>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  props: {
    subscriptionEndDate: {
      type: String,
    },
    trial: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'endSubscription'],
  computed: {
    buttonText() {
      return this.trial ? 'End my trial membership' : 'End my membership';
    },
    title() {
      return this.trial ? 'Did you click to cancel your trial by accident?' : 'Did you click to cancel your membership by accident?';
    },
  },
};
</script>

<style lang="scss">
  .cancel-subscription-modal {
    border-radius: rem-calc(10);
    background-color: #ffffff;
    text-align: center;
    width: rem-calc(620);
    max-width: 98%;
    padding: 0 rem-calc(42);

    @include breakpoint(small) {
      margin-left: 1%;
      padding: 0 rem-calc(20);
    }

    .close-btn {
      right: rem-calc(6);
      position: absolute;
      top: rem-calc(6);
      background: transparent;
      border: none;
      padding: 0;
      opacity: 0.4;

      @include breakpoint(small) {
        right: rem-calc(4);
      }

      img {
        height: rem-calc(20);
        width: rem-calc(20);

        @include breakpoint(small) {
          height: rem-calc(24);
          width: rem-calc(24);
        }
      }
    }

    .warning-container {
      background-color: #dc3416;
      height: rem-calc(60);
      width: rem-calc(60);
      border-radius: 50%;
      padding: rem-calc(12) rem-calc(14);
      box-sizing: border-box;
      margin: rem-calc(41) auto 0;

      img {
        height: rem-calc(31);
      }
    }

    .title {
      font-size: rem-calc(32);
      font-weight: $bold;
      color: #000000;
      margin: rem-calc(27) auto rem-calc(18);
    }

    p:not(.title),
    li {
      line-height: 1.5;
      margin: 0;
      font-weight: normal;
    }

    .semi-bold {
      font-weight: $semi-bold;
    }

    ul {
      padding: 0 rem-calc(50);
      li {
        margin-top: rem-calc(16);
        text-align: left;
      }
    }

    .reset-btn,
    .cancel-btn {
      display: block;
    }

    .reset-btn {
      border-radius: rem-calc(8);
      background-color: #dc3416;
      color: #ffffff;
      font-size: rem-calc(22);
      font-weight: $semi-bold;
      padding: rem-calc(15) rem-calc(28);
      margin: rem-calc(41) auto 0;
    }

    .cancel-btn {
      margin: rem-calc(32) auto;
      background: transparent;

      &:hover {
        text-decoration: underline;
      }
    }
  }
</style>
